// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import './numberFieldEditor';

/**
 * Editor for fields of type double<br/>
 * @name DoubleFieldEditor
 * @constructor
 * @extends {NumberFieldEditor}
 */
myw.DoubleFieldEditor = myw.NumberFieldEditor.extend({
    options: {
        unitValueOptions: {
            minimumFractionDigits: 0, //minimumFractionDigit to lowest possible
            maximumFractionDigits: 20 //maximumFractionDigit to highest possible
        }
    },

    validateValue(value) {
        if (this.control.validity && !this.control.validity.valid) {
            return this.control.validity.message || this.msg('invalid_number');
        }

        //check if the value is an double
        if (value != parseFloat(value)) return this.msg('invalid_double');

        return myw.NumberFieldEditor.prototype.validateValue.apply(this, [value]);
    }
});

export default myw.DoubleFieldEditor;
